import { UseFormReturn } from 'react-hook-form';
import { MiscellaneousField } from '../../reportsTypes';
import {
  DayTimeDurationPickerV2,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
  InfoIconTooltip,
} from '@ais-ui/ui-core';

interface DayTimeDurationItemProps {
  fieldName: string;
  form: UseFormReturn;
  fieldInfo: MiscellaneousField;
}

export const MiscellaneousDayTimeDurationItem = ({
  fieldName,
  form,
  fieldInfo,
}: DayTimeDurationItemProps) => {
  return (
    <FormField
      key={fieldName}
      control={form.control}
      name={fieldName}
      render={({ field }) => (
        <FormItem>
          <div className="flex justify-between">
            <FormLabel>
              {fieldInfo.name}: {fieldInfo.required && '*'}
            </FormLabel>
            {fieldInfo.help && (
              <InfoIconTooltip className="mr-2">
                {fieldInfo.help}
              </InfoIconTooltip>
            )}
          </div>
          <FormControl onChange={() => form.clearErrors()}>
            <DayTimeDurationPickerV2
              value={field.value ?? { days: 0, hours: 0, minutes: 0 }}
              onChange={field.onChange}
            />
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  );
};
